import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URLS } from '../config/api.urls';
import { Testimonial } from '../_models/testimonial';

@Injectable({
    providedIn: 'root'
})
export class TestimonialService {

    constructor(private httpClient: HttpClient) { }

    loadAll(): Observable<any> {
        return this.httpClient.get(API_URLS.TESTIMONIALS);
    }

    loadAllAdmin(): Observable<any> {
        return this.httpClient.get(API_URLS.SECURE_TESTIMONIALS);
    }

    loadOne(id: string): Observable<any> {
        return this.httpClient.get(API_URLS.SECURE_TESTIMONIALS + '/' + id);
    }

    save(testimonial: Testimonial, photo: Blob | null) {
        if (!testimonial.id) {
            return this.add(testimonial, photo);
        } else {
            return this.update(testimonial, photo);
        }
    }

    add(testimonial: Testimonial, photo: Blob | null) {
        return this.httpClient.post(API_URLS.SECURE_TESTIMONIALS, this.buildFormData(testimonial, photo));
    }

    update(testimonial: Testimonial, photo: Blob | null) {
        return this.httpClient.put(API_URLS.SECURE_TESTIMONIALS + '/' + testimonial.id, this.buildFormData(testimonial, photo));
    }

    delete(id: string) {
        return this.httpClient.delete(API_URLS.SECURE_TESTIMONIALS + '/' + id);
    }

    private buildFormData(testimonial: Testimonial, photo: Blob | null) {
        const formData = new FormData();
        if (photo) {
            formData.append('file', photo);
        }
        const dataBlob = new Blob(
            [JSON.stringify({
                displayName: testimonial.displayName,
                comment: testimonial.comment,
                jobTitle: testimonial.jobTitle,
                company: testimonial.company,
                location: testimonial.location
            })],
            { type: 'application/json' }
        );
        formData.append('data', dataBlob);
        return formData;
    }
}
